import { withInstall } from '@pit-element-plus/utils'
import Divider from './src/divider.vue'

import type { SFCWithInstall } from '@pit-element-plus/utils'

export const ElDivider: SFCWithInstall<typeof Divider> = withInstall(Divider)
export default ElDivider

export * from './src/divider'
